import React from 'react';

const UnderConstructionPage = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
      <h1>Page under construction</h1>
    </div>
  );
};

export default UnderConstructionPage;
